import { render, staticRenderFns } from "./OrdiniViewComponent.vue?vue&type=template&id=0f4d0414&scoped=true"
import script from "./OrdiniViewComponent.vue?vue&type=script&lang=js"
export * from "./OrdiniViewComponent.vue?vue&type=script&lang=js"
import style0 from "./OrdiniViewComponent.vue?vue&type=style&index=0&id=0f4d0414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d0414",
  null
  
)

export default component.exports